import { Card, Divider, Grid, Icon, InputAdornment, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import UserCard from './UserCard';

function UsersToSelect({ hadnleHostUserSelect, hostUserSelected }) {
  const [searchUser, setSearchUser] = useState('');
  const { userList } = useSelector((state) => state.dagpacket);

  const filteredUsers = userList?.filter((user) => {
    if (searchUser === '') {
      return user;
    }
    if (user?.displayName.toLowerCase().includes(searchUser.toLowerCase())) {
      return user;
    }
    return false;
  });
  return (
    <Card sx={{ padding: '15px' }}>
      <Typography variant="subtitle2">Asignar licenciatario</Typography>
      <Divider />

      <TextField
        sx={{ marginTop: '15px' }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Icon fontSize="25px" icon="eva:search-fill" />
            </InputAdornment>
          )
        }}
        label="Buscar usuario"
        variant="outlined"
        value={searchUser}
        onChange={(e) => setSearchUser(e.target.value)}
      />

      <Grid marginTop="10px" container spacing={1}>
        {searchUser &&
          filteredUsers.map((user) => (
            <UserCard
              key={user.id}
              dataUser={user}
              hadnleHostUserSelect={hadnleHostUserSelect}
              hostUserSelected={hostUserSelected}
            />
          ))}
      </Grid>
    </Card>
  );
}

export default UsersToSelect;
